var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('Title',{attrs:{"titlePage":_vm.titlePage}})],1),_c('v-container',[_c('ContactForm',{attrs:{"contact":_vm.contact},on:{"contact":_vm.createOrUpdadateContact}}),_c('Popup',{attrs:{"dialog":_vm.dialog,"text":_vm.messageCreation,"actions":_vm.actions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }